(function() {

    const WebFont = require('webfontloader');

    WebFont.load({

        google: {
            families: ['Lato:300,400,700,900:latin-ext']
        }
    });
})();

